'use client';

import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogTitle } from '@/shared/components/ui/dialog';
import { ContentCreationWizard } from './index';

interface WizardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  preselectedStoryId: string;
  /** Block count of preselected story (for accurate cost estimation) */
  preselectedStoryBlockCount?: number;
  preselectedStoryTotalChars?: number;
  /** Language of preselected story — drives voice resolution for extend flows */
  preselectedStoryLanguage?: string;
  /** Age group of the preselected story — the default comic sub-style of a new book */
  preselectedStoryAgeGroup?: string;
  defaultScenario?: string;
  locale: string;
  onComplete?: (result: { type: string; entityId: string; planId?: string }) => void;
  /** Called immediately when the creation mutation starts */
  onMutationStart?: () => void;
}

export function WizardDialog({ open, onOpenChange, locale, ...wizardProps }: WizardDialogProps) {
  const t = useTranslations('content.wizard');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Full screen on a phone; ONE fixed width on everything larger.
          `sm:w-auto` used to size the dialog to whatever step was open, so the
          short ones — pick a voice, pick a format — came up as a narrow column
          in the middle of a desktop screen, and the box resized under the
          parent's hands as they stepped through it. */}
      <DialogContent
        showCloseButton={false}
        className="w-full h-full max-w-full max-h-full rounded-none border-0 sm:w-[48rem] sm:max-w-[calc(100vw-4rem)] sm:max-h-[90vh] sm:rounded-lg sm:border !flex flex-col overflow-hidden p-3 sm:p-6"
      >
        <DialogTitle className="sr-only">{t('dialogTitle')}</DialogTitle>
        <ContentCreationWizard
          {...wizardProps}
          locale={locale}
          asModal
          onMutationStart={() => {
            wizardProps.onMutationStart?.();
          }}
          onComplete={(result) => {
            onOpenChange(false);
            wizardProps.onComplete?.(result);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
